import apiClient from '../apiClient';

export const fetchPublicHiringLocations = async () => {
  const response = await apiClient.get('/public/hiring/locations');
  const data = Array.isArray(response?.data) ? response.data : [];
  return data.map((location) => ({
    id: location?.id ?? location?._id ?? '',
    name: location?.name ?? '',
    address: location?.address ?? '',
    suggestedPositions: Array.isArray(location?.suggestedPositions)
      ? location.suggestedPositions
      : [],
  }));
};

export const submitPublicJobApplication = async (locationId, positionId, payload) => {
  const response = await apiClient.post(
    `/public/hiring/locations/${locationId}/positions/${positionId}/applications`,
    payload,
  );

  return response?.data;
};

export default {
  fetchPublicHiringLocations,
  submitPublicJobApplication,
};
